/**
 * Featured Webinar
 */
import { Component, registerComponent } from 'js/component.js';
import { DateTime } from 'luxon';

const componentName = 'featured-webinar';

class FeaturedWebinar extends Component {
    /** Component elements */
    elements = {
        container: this.element.querySelector(`.${componentName}__container`),
    };

    /** Initialize components */
    init() {
        if (this.elements.container != null) {
            const webinarOnDemand = this.elements.container.getAttribute('data-webinar-on-demand');
            const webinarType = this.elements.container.getAttribute('data-webinar-type');
            const tileDate = this.elements.container.querySelector('.date-details');
            const tileTime = this.elements.container.querySelector('.time-details');

            const webinarTimeZone = webinarOnDemand != null ? webinarOnDemand.substring(webinarOnDemand.indexOf('[') + 1, webinarOnDemand.length - 1) : '';
            const onDemandInWebinarZone = DateTime.fromISO(webinarOnDemand).setZone(webinarTimeZone);
            const nowInWebinarZone = DateTime.now().setZone(webinarTimeZone);
            const siteTimezone = document.querySelector('html').getAttribute('data-timezone');

            let locale = (document.documentElement.lang || 'en-US')
                .replace('-__', '')
                .replace('_', '-');
            if (locale.toLowerCase() === 'en-mde') {
                locale = 'en-GB';
            }

            const webinarInstances = this.elements.container.getAttribute('data-webinar-instances');
            if (webinarInstances != null) {
                const instanceArrayAll = webinarInstances.split(',');
                let instanceArrayFuture = [];
                for (let i = 0; i < instanceArrayAll.length; i += 1) {
                    if (instanceArrayAll[i] > nowInWebinarZone.toString()) {
                        instanceArrayFuture = instanceArrayAll.slice(i);
                        break;
                    }
                }

                if (instanceArrayFuture.length !== 0) {
                    // Replace initial webinar details with next future instance
                    const instanceToDisplay = instanceArrayFuture[0].split('--');
                    const webinarDateTime = instanceToDisplay[0];
                    const displayDateTime = DateTime.fromISO(webinarDateTime).setZone(siteTimezone);
                    const displayDate = displayDateTime.setLocale(locale).toLocaleString(DateTime.DATE_FULL);
                    const displayTime = displayDateTime.setLocale(locale).toLocaleString(DateTime.TIME_SIMPLE).replace(/M/, '.M.')
                        .concat(' ', siteTimezone === 'Europe/Istanbul' ? 'Turkey Time' : displayDateTime.setLocale(locale).toFormat('ZZZZZ'));

                    if (tileDate) {
                        tileDate.innerHTML = tileDate.innerHTML.substring(0, tileDate.innerHTML.indexOf('/span>') + 7).concat(displayDate);
                    }
                    if (tileTime) {
                        tileTime.innerHTML = tileTime.innerHTML.substring(0, tileTime.innerHTML.indexOf('/span>') + 7).concat(displayTime);
                    }
                }
            }

            let activeLabel;

            if (webinarType.toLowerCase() === 'series') {
                activeLabel = this.element.querySelector(`.${componentName}__webinar-label_series`);
            } else if (nowInWebinarZone < onDemandInWebinarZone) {
                this.elements.container.setAttribute('data-webinar-type', 'future webinar');
                activeLabel = this.element.querySelector(`.${componentName}__webinar-label_future`);
            } else {
                this.elements.container.setAttribute('data-webinar-type', 'past webinar');
                activeLabel = this.element.querySelector(`.${componentName}__webinar-label_past`);
            }
            activeLabel.classList.add('active');
        }
    }
}

registerComponent(`.${componentName}`, FeaturedWebinar);
